//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';



//  -- List books ----------------
export const invokeBingoModal = () => ({ type: ActionTypes.bingo.invokeBingoModal });
export const revokeBingoModal = () => ({ type: ActionTypes.bingo.revokeBingoModal });

//  -- List All books ----------------
